export default {
  data () {
    return {
      queryModules: [
        'esri/tasks/QueryTask',
        'esri/tasks/support/Query'
      ],
      queryTask: null,
      queryTarget: null
    }
  },
  methods: {
    createQueryTask () {
      if (!this.gisConfig.queryTask) return console.error(`JSON配置文件节点：queryTask值无效`)
      this.queryTask = new this.gisConstructor.QueryTask({ url: this.gisConfig.queryTask })
      this.queryTarget = new this.gisConstructor.Query()
    },
    // 设置查询参数
    queryTaskConfig ({ longitude, latitude }, fields = ['*']) {
      if (!this.queryTarget) return
      this.queryTarget.returnGeometry = false // 若设为false，则不再返回几何对象，只返回属性值
      this.queryTarget.units = 'meters'
      this.queryTarget.spatialRelationship = 'intersects' // 默认值
      this.queryTarget.outFields = fields // * 代表所有字段值都返回，数据量大时没必要
      // this.queryTarget.outFields = ['NAME', 'BM'] // 返回指定属性字段值
      /* 所有字段示例: {
        ADDRESS: "XXX4、6-10号楼"
        BM: "12011000200710"
        CENTER_X: 117.32135412
        CENTER_Y: 39.08996866
        NAME: "XXX社区10网格"
        OBJECTID: null
        OBJECTID_1: 13068
        SHAPE.AREA: 0.0000034600685538435003
        SHAPE.LEN: 0.00984784095072605
        SQ_CATALOG: "还迁房网格"
        SQ_TYPE: "1"
        SSJB: "丰年村街"
        SSSQ: "新泰道社区"
        SSXZQH: "东丽区"
        TYPE: 0
      } */
      this.queryTarget.geometry = new this.gisConstructor.Point(longitude, latitude, this.view.spatialReference)
    },
    async startQueryTask (point, fields) {
      let longitude = point.longitude || point.x || 0
      let latitude = point.latitude || point.y || 0
      if (!longitude || !latitude) return console.warn(`queryTask：地图查询点位无效`, point)
      this.queryTaskConfig({ longitude, latitude }, fields)
      const data = await this.queryTask.execute(this.queryTarget)
      return data.features
    }
  }
}
